import type { ControllerRenderProps } from "react-hook-form";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { IContactInfo } from "@b2bportal/core-types";
import { uniquePhoneCodes } from "@hopper-b2b/ui";
import { Select, SelectItem } from "@tenant/ui";

export interface CountryCodeProps
  extends PlatformComponentProps,
    ControllerRenderProps<IContactInfo, "countryCode"> {
  defaultValue?: string;
  onValueChange?: (value: string) => void;
}

export const CountryCode = (props: CountryCodeProps) => {
  const countryCodeOptions = uniquePhoneCodes.map((countryCode) => ({
    key: countryCode,
    value: `+${countryCode}`,
  }));
  const { className, defaultValue, onValueChange, ...field } = props;
  return (
    <Select
      {...field}
      className={className}
      onValueChange={onValueChange}
      defaultValue={defaultValue ?? field.value}
    >
      {countryCodeOptions.map((item, index) => {
        return (
          <SelectItem
            key={item.key || `${item.value}-${index}`}
            value={item.value}
          >
            {item.value}
          </SelectItem>
        );
      })}
    </Select>
  );
};
